import React from "react";

const ErrorPage404 = () => {
  return <div>ErrorPage404</div>;
};

export default ErrorPage404;
